import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  OnDestroy,
} from '@angular/core';
import {
  ActiveTabState,
  TabSelectAction,
} from '@ansys-internal/awf-angular/workspace';
import { State } from '@ansys-internal/awf-angular/store';
import { Subject } from 'rxjs';
import { Typography } from '@ansys-internal/awc-angular/core';
import { CommonModule } from '@angular/common';
import { InputComponent } from '@ansys-internal/awc-angular/forms';
import { ConceptMetaState } from '../../../../state/lib/concept-meta.state';
import { ConceptService } from '../../../../shared/services/concept.service';
import { FeatureFlagsEnum } from '../../../../shared/enums/feature-flags.enum';
import { SharedModule } from '../../../../shared/shared.module';
import { FeatureFlagModule } from '../../../../shared/modules/feature-flag.module';
import {
  ActionContributionsService,
  WorkspaceTab,
} from '@ansys-internal/awf-angular/contributions';
import { LoadingSkeletonComponent, LoadingSkeletonType } from "@ansys-internal/awc-angular/loading-skeleton";

@Component({
    selector: 'app-concept-title',
    templateUrl: './concept-title.component.html',
    styleUrls: ['./concept-title.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [
        LoadingSkeletonComponent,
        CommonModule,
        FeatureFlagModule,
        InputComponent,
        SharedModule,
    ]
})
export class ConceptTitleComponent implements OnDestroy {
  protected projectTitle: string = 'Project';
  protected branchTitle: string = 'Branch';
  protected versionTitle: string = 'Version';
  protected loading: boolean = false;
  protected width: number = 100;
  protected lineHeight: Typography = Typography.CAPTION;
  protected type: LoadingSkeletonType = LoadingSkeletonType.LINE;
  protected readonly featureFlagsEnum = FeatureFlagsEnum;
  protected isEditing: boolean = false;
  protected editField: string = '';
  protected editValue: string = '';
  protected show: boolean = false;
  private destroy$$: Subject<boolean> = new Subject<boolean>();

  constructor(
    private state: State,
    private cdr: ChangeDetectorRef,
    protected conceptService: ConceptService,
    private actions: ActionContributionsService
  ) {
    this.state.get(ActiveTabState).subscribe(() => {
      this.loading = true;
      this.cdr.markForCheck();
    });

    this.actions.get(TabSelectAction).subscribe((tab?: WorkspaceTab) => {
      this.show = tab?.path === 'concept';
      this.cdr.markForCheck();
    });

    this.state.get(ConceptMetaState).subscribe((conceptMetaState) => {
      if (conceptMetaState) {
        this.projectTitle = conceptMetaState.projectTitle;
        this.branchTitle = conceptMetaState.projectBranch;
        this.loading = false;
        this.cdr.detectChanges();
      }
    });
  }

  ngOnDestroy(): void {
    this.destroy$$.next(true);
    this.destroy$$.complete();
  }

  protected onEditTitle(field: string): void {
    this.editField = field;
    switch (this.editField) {
      case 'project':
        this.editValue = this.projectTitle;
        break;
      case 'branch':
        this.editValue = this.branchTitle;
        break;
      case 'version':
        this.editValue = this.versionTitle;
        break;
    }
    this.isEditing = true;
  }

  protected finishEditing(): void {
    switch (this.editField) {
      case 'project':
        this.projectTitle = this.editValue;
        this.conceptService.updateProject(this.projectTitle);
        break;
      case 'branch':
        this.branchTitle = this.editValue;
        this.conceptService.updateFile(this.branchTitle);
        break;
      case 'version':
        this.versionTitle = this.editValue;
        break;
    }
    this.isEditing = false;
  }

  protected cancelEditing(): void {
    this.isEditing = false;
  }
}
